<ng-container>
  <table class="table marginTopTwentyPx" aria-label="Documents in Package">
    <thead>
      <tr>
        <th scope="col" (click)="sortDocuments('name')" (keyup)="sortDocuments('name')" class="sortable-heading">
          Document Name
          @if (sortColumn === 'name') {
            <img [src]="getSortIcon('name')" alt="Sort Icon">
          }
        </th>
        <th scope="col" (click)="sortDocuments('actionType')" (keyup)="sortDocuments('actionType')" class="sortable-heading">
          Action Type
          @if (sortColumn === 'actionType') {
            <img [src]="getSortIcon('actionType')" alt="Sort Icon">
          }
        </th>
        <th scope="col" (click)="sortDocuments('digitized')" (keyup)="sortDocuments('digitized')" class="sortable-heading">
          Digitized
          @if (sortColumn === 'digitized') {
            <img [src]="getSortIcon('digitized')" alt="Sort Icon">
          }
        </th>
        <th scope="col" (click)="sortDocuments('uploaded')" (keyup)="sortDocuments('uploaded')" class="sortable-heading">
          Uploaded
          @if (sortColumn === 'uploaded') {
            <img [src]="getSortIcon('uploaded')" alt="Sort Icon">
          }
        </th>
        <th scope="col" (click)="sortDocuments('status')" (keyup)="sortDocuments('status')" class="sortable-heading">
          Status
          @if (sortColumn === 'status') {
            <img [src]="getSortIcon('status')" alt="Sort Icon">
          }
        </th>
        <th scope="col" (click)="sortDocuments('preSignEligible')" (keyup)="sortDocuments('preSignEligible')" class="sortable-heading">
          Pre-Sign Eligible
          @if (sortColumn === 'preSignEligible') {
            <img [src]="getSortIcon('preSignEligible')" alt="Sort Icon">
          }
        </th>
        <th scope="col">Actions</th>
      </tr>
    </thead>
    <tbody>
      @for (doc of documents; track doc) {
        <tr data-cy="documentRecord">
          <td [attr.data-cy]="'doc-' + doc.id" class="document-column">
            @if (!isOrderLocked && !doc.isVoid) {
              <a
            [allowLinkIfHasCapability]="[{
              capabilityString: 'CanEditDocument',
              type: 'document',
              id: doc?.id
            }]"
                class="nav-link"
                (click)="openDocumentEditor(documents, doc.id, doc.isSmartDoc)"
                (keyup)="openDocumentEditor(documents, doc.id, doc.isSmartDoc)">
                {{ doc.name }}
              </a>
            } @else {
              <span>{{ doc.name }}</span>
            }
          </td>
          <td>{{ doc.isPaper ? 'Print' : 'eSign' }}</td>
          <td>{{ doc.isDigitized ? 'Yes' : 'No' }}</td>
          <td>{{ doc.createdDate | date:'short' }}</td>
          <td [title]="getViolationMessage(doc)">{{ doc.status }}</td>
          <td>{{ doc.isDocPreSign ? 'Yes' : 'No' }}</td>
          <td>
            <div>
              @if (!(isOrderLocked$ | async)) {
                <img
              [showIfHasCapability]="[{
                capabilityString: 'CanEditDocument',
                type: 'document',
                id: doc?.id
              }]"
                  (click)="openDocumentEditor(documents, doc.id, doc.isSmartDoc)"
                  (keyup)="openDocumentEditor(documents, doc.id, doc.isSmartDoc)"
                  title="Edit Document"
                  class="action-item"
                  src="assets/icons/edit.svg" alt="Edit Document"
                  >
              }
              <img
              [showIfHasCapability]="[{
                capabilityString: 'CanReadDownloadMyDocument',
                type: 'document',
                id: doc?.id
              }]"
                (click)="displayPackageDocument(doc.id, doc.isSmartDoc, doc.name)"
                (keyup)="displayPackageDocument(doc.id, doc.isSmartDoc, doc.name)"
                title="Download Document"
                class="action-item"
                src="assets/icons/downloadIcon.svg" alt="Download Document"
                >
                @if (!(isOrderLocked$ | async)) {
                  <img
              [showIfHasCapability]="[{
                capabilityString: 'CanRemoveDocument',
                type: 'document',
                id: doc?.id
              }]"
                    (click)="onDeleteDocument(doc.id, doc.status)"
                    (keyup)="onDeleteDocument(doc.id, doc.status)"
                    title="Delete Document"
                    class="action-item"
                    src="assets/icons/trash.svg" alt="Delete Document"
                    >
                }
              </div>
            </td>
          </tr>
        }
      </tbody>
    </table>
  </ng-container>
